export default __webpack_public_path__ + "static/discover_0-ed63774453595a583ca7a8c8db54c367.jpg";